import React, { Component } from 'react';

import { adminUser, managerUser } from '../../utilities/Forms.js'
import { request, handleRequestErrors } from '../../helpers/Requests'

class CreateCheckOutButton extends Component {
  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    showModal: false,
    date: this.initialDate(),
    time: this.initialTime(),

    errors: ""
  }

  initialDate() {
    const date = this.props.check_in_date || new Date();
    return `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}`
  }

  initialTime() {
    const date = this.props.check_in_date || new Date();
    return `${("0" + date.getHours()).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}`
  }

  openModal(event) {
    this.setState({showModal: true})

    event.preventDefault();
  }

  closeModal(event) {
    this.setState({showModal: false})

    event.preventDefault();
  }

  handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;

    this.setState({[name]: value});
  }

  handleSubmit(event) {
    const json = JSON.stringify({
      "event": {
        "person_id": this.props.person_id,
        "location_id": this.props.location_id,
        "reported_check_out": `${this.state.date} ${this.state.time}`
      }
    })

    request("POST", `/v1/a/events/create_check_out`, json, () => {this.setState({unauthorized: true})})
      .then(data => {
        this.setState({
          errors: "",
          showModal: false
        })
        sessionStorage.setItem("updateSuccess", "Event updated successfully!");

        // A callback fired on success can be used to update data on the page this request took place
        // or it could be used to simply force the PopupBox to show the success message
        if (this.props.successCallback) {
          this.props.successCallback(data);
        }
      })
      .catch(error => handleRequestErrors(this, error, { error, loaded: true }))

    event.preventDefault();
  }

  renderModal() {
    if (this.state.showModal) {
      return (
        <div className="modal-container">
          <div className="modal-content manual-check-out">
            <div className="modal-title">Create Check Out</div>
            {this.renderErrors()}
            <div>Please enter the date and time for this Persons Check Out event:</div>
            <input type="date" name="date" value={this.state.date} onChange={this.handleChange} />
            <input type="time" name="time" value={this.state.time} onChange={this.handleChange} />

              <div className="center-two-buttons">
                <button className="small button" onClick={this.handleSubmit}>Submit Check Out</button>
                <button className="small button" onClick={this.closeModal}>Cancel</button>
              </div>
          </div>
        </div>
      )
    }
  }

  renderErrors() {
    if (this.state.errors) {
      let array = []
      for (let key in this.state.errors) {
          array = array.concat(this.state.errors[key])
      }
      return(
        array.map((item, index) => (
          <label key={index} className="column red-text">{item}</label>
        ))
      )
    }
  }

  render() {
    const person_id = this.props.person_id;
    const location_id = this.props.location_id;
    const className = this.props.className ? " " + this.props.className : "";

    if (person_id && location_id && (adminUser() || managerUser())) {
      return (
        <>
          <div className={"small button no-print" + className} onClick={this.openModal}>Create Check Out</div>
          {this.renderModal()}
        </>
      );
    }
  }
}

export default CreateCheckOutButton;
